import React from 'react';
import { isEmpty, uniqueId } from 'underscore';
import { UncontrolledTooltip } from 'reactstrap';
import { faCommentAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Comment = ({ text }) => {
  if (isEmpty(text)) {
    return (
      <FontAwesomeIcon icon={faCommentAlt} className="text-muted2x"></FontAwesomeIcon>
    );
  }

  const id = `comment-${uniqueId()}`;

  return (
    <>
      <FontAwesomeIcon icon={faCommentAlt} id={id}></FontAwesomeIcon>
      <UncontrolledTooltip placement="left" target={id}>{text}</UncontrolledTooltip>
    </>
  );
};

export default Comment;
